<template>
	<div tabindex="0" class="hide-outline" :class="this.isMobile ? 'is-mobile' : ''">
		<main class="main-view no-top-panel">
			<div>
				<div class="summary title">
					 {{ $t('move_summary.title') }}
				</div>
				<div class="top-box">
					<div class="row">
						<div class="fields">
							<div class="field">
								<label class="label">{{ $t('move_summary.from_customer') }}</label>
								<div class="customer-box">{{ localMove.fromCustomerName }}</div>
							</div>
							<div class="field">
								<label class="label">{{ $t('move_summary.to_customer') }}</label>
								<div class="customer-box">{{ localMove.targetCustomerName }}</div>
							</div>
							<div class="field">
								<label class="label">{{ $t('move_summary.status') }}</label>
								<div class="customer-box compact">{{ moveStatus }}</div>
							</div>
						</div>
						
						<div class="field buttons">
							<button @click="navigateBack" class="button is-dark">
								<span class="icon"><i class="fas fa-backward"/></span>
								<span>{{ $t('move_summary.back') }}</span>
							</button>
							<button v-if="localMove.moveStatus === 1" @click="rollbackMove" class="button is-dark" :class="loading ? 'is-loading' : ''" :disabled="disableActions">
								<span class="icon"><i class="fas fa-undo"/></span>
								<span>{{ $t('move_summary.rollback') }}</span>
							</button>
							<button v-if="localMove.moveStatus != 2" @click="doMove" class="button is-info" :class="loading ? 'is-loading' : ''" :disabled="disableActions">
								<span class="icon"><i class="fas fa-check"/></span>
								<span>{{ localMove.moveStatus === 0 ? $t('move_summary.execute') : $t('move_summary.approve') }}</span>
							</button>
						</div>
					</div>
				</div>
				<div class="warning" :key="'warning' + index" v-for="(warning, index) in errors">{{ warning }}</div>
				<div
					v-for="building in localMove.moveBuildings"
					:key="building.id"
					class="building-card"
				>
					<div style="display: flex">
						<p class="building-title">{{ building.buildingName }}</p>
						<p class="move-type-box">{{ getMoveType(building.moveType) }}</p>
					</div>
					<SummaryList
						:title="$t('move_summary.round_plannings')"
						:listItems="building.roundPlannings"
						displayName="roundPlanningName"
						:sublists="sublists"
						:moveStatus="localMove.moveStatus"
					>
						<SummaryList
							:title="$t('move_summary.questions')"
							displayName="questionName"
							:moveStatus="localMove.moveStatus"
						/>
					</SummaryList>
					
					<SummaryList
						:title="$t('move_summary.users')"
						:listItems="building.users"
						:moveStatus="localMove.moveStatus"
					/>
                    
				</div>
			</div>
		</main>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import moveWizard from '@/services/moveWizard';
import SummaryList from './components/SummaryList';

export default {
	components: {
		SummaryList
	},
	data() {
		return {
			localMove: {
				moveBuildings: []
			},
			sublists: [],
			errors: []
		};
	},
	computed: {
		...mapGetters('appStore', ['isMobile', 'loading']),
		moveStatus() {
			switch(this.localMove.moveStatus) {
				case 0:
					return this.$t('move_summary.status_open');
				case 1:
					return this.$t('move_summary.status_started');
				case 2:
					return this.$t('move_summary.status_completed');
			}
			return '';
		},
		disableActions() {
			return this.loading > 0;
		}
	},
	methods: {
		setLocalMove(moveObject) {
			this.localMove = moveObject;
			
			this.localMove.moveBuildings.forEach(building => {
				building.roundPlannings.forEach(roundPlanning => {
					roundPlanning.questionGroups = this.formatQuestionsIntoGroups(roundPlanning.questions);
				});
			});
		},
		formatQuestionsIntoGroups(questionList) {
			let uniqueQuestions = questionList;
			let questionGroups = [];

			uniqueQuestions.forEach(question => {
				let foundGroup = questionGroups.find(group => group.id == question.oldQuestionGroupId);
				
				if (!foundGroup) {
					questionGroups.push({
						moveType: question.moveType,
						id: question.oldQuestionGroupId,
						questionGroupName: question.oldQuestionGroupName,
						questions: [question]
					});
				} else {
					foundGroup.questions.push(question);
				}
			});
			
			return questionGroups;
		},
		getMoveType(moveTypeNumber) {
			let moveStarted = this.localMove.moveStatus > 0;

			switch (moveTypeNumber) {
				case 0: return this.$t(moveStarted ? 'summary_list.copied' : 'summary_list.copy');
				case 1: return this.$t(moveStarted ? 'summary_list.moved' : 'summary_list.move');
				case 2: return this.$t(moveStarted ? 'summary_list.replaced' : 'summary_list.replace');
				case 3: return this.$t(moveStarted ? 'summary_list.ignored' : 'summary_list.ignore');
				case 4: return this.$t(moveStarted ? 'summary_list.cross_connected' : 'summary_list.cross_connect');
			}

			return '';
		},
		navigateBack() {
			if (this.localMove.moveStatus === 0) {
				this.$router.push({ name: 'MoveWizardView', params: { moveId: this.localMove.id } });	
			} else {
				this.$router.push({ name: 'OngoingMovesView' });
			}
		},
		doMove() {
			this.errors = [];
			
			if (this.localMove.moveStatus === 0) {
				moveWizard.executeMove(this.localMove.id).then(() => {
					moveWizard.getMoveSummary(this.localMove.id).then(data => {
						this.setLocalMove(data);
					});
				}).catch(error => {
					this.handleErrorResponse(error);
				});
			} else if (this.localMove.moveStatus === 1) {
				moveWizard.approveMove(this.localMove.id).then(() => {
					moveWizard.getMoveSummary(this.localMove.id).then(data => {
						this.setLocalMove(data);
					});
				}).catch(error => {
					this.handleErrorResponse(error);
				});
			}
		},
		rollbackMove() {
			moveWizard.rollbackMove(this.localMove.id).then(() => {
				moveWizard.getMoveSummary(this.localMove.id).then(data => {
					this.setLocalMove(data);
				}).catch(error => {
					this.handleErrorResponse(error);
				});
			});
		},
		handleErrorResponse(error) {
			console.log(error);
			
			if (error.response.status == 400) {
				this.errors.push(error.response.data);
			} else {
				this.errors.push(error.message);
			}
		}
	},
	created() {
		let moveId = this.$route.params.moveId;

		if (!this.getActiveCustomer?.id && moveId == 0) {
			this.$router.push(`/${this.$i18n.locale}/OngoingMoves`);
		}

		moveWizard.getMoveSummary(moveId).then(data => {
			this.setLocalMove(data);
		});

		this.sublists = [
			{
				title: this.$t('move_summary.roles'),
				sublistName: 'roles',
				sublistItemName: 'roleName'
			},
			{
				title: this.$t('move_summary.fire_protections'),
				sublistName: 'fireProtections',
				sublistItemName: 'fireProtectionName'
			},
			{
				title: this.$t('move_summary.checklists'),
				sublistName: 'questionLists',
				sublistItemName: 'questionListName'
			},
			{
				title: this.$t('move_summary.question_groups'),
				sublistName: 'questionGroups',
				sublistItemName: 'questionGroupName',
				sublists: [
				{
					sublistName: 'questions',
					sublistItemName: 'questionName'
				}
				],
				collapsedSublist: true
			}
		];
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/colors.scss";

.summary.title {
	margin-bottom: 1rem;
}

.building-card {
	padding: 0.5rem;
	margin: 0.5rem 0;
	background: #f5f5f5;
	border: 1px solid #eeeeee;
	.building-title {
			font-size: 18px;
			font-weight: 600;
	}

	.sublist {
		margin-top: 1rem;
		border-bottom: 1px solid #e7e7e7;
		.list-item {
			display: flex;
			margin-left: 0.25rem;
			margin-bottom: 0.25rem;
			&:not(:last-child) {
				border-bottom: 1px solid #eeeeee;
			}
			.list-item-text {
				padding: 2px;
				margin-right: 0.5rem;
			}
		}
	}

	.subtitle {
		margin-bottom: 0;
		font-size: 16px;
		font-weight: 600;
	}

	.item-card {
		padding: 2px;
		display: flex;
		:first-child {
			padding: 2px;
			margin-right: 1rem;
		}
	}

	.move-type-box {
		margin-left: 0.5rem;
		padding: 2px 0.25rem;
		background: $dark;
		color: white;
		border: 1px solid #eeeeee;
		max-height: 30px;
	}
}

.top-box {
  background: $lightest-grey;
  padding: 10px 5px 10px 5px;
  display: block;
  border-radius: 2px;
  margin-bottom: 10px;
  .row {
    display: flex;
		flex-wrap: wrap;
    position: relative;
  }
  .field {
    flex: 1;
    margin-left: 10px;
    margin-right: 10px;
    .label {
      font-size: 12px;
    }
  }
  .buttons {
    width: 100%;
    margin-top: 10px;
    justify-content: flex-end;
    &.is-mobile {
      margin-top: 1.2rem;
      margin-right: 0.7rem;
    }
    .button {
      border-radius: 2px;
			min-width: 110px;
    }
  }
	
	.fields {
		display: flex;
	}
	
  .customer-box {
    min-height: 40px;
    min-width: 300px;
    padding: 5px 0.5rem;
    background: white;
    border: 1px solid #eeeeee;
    font-size: 18px;
		&.compact {
			min-width: 150px;
		}
	}
}

.warning {
	color: $danger;
	font-weight: 600;
	font-size: 14px;
}
</style>